import React from 'react';
import isPropValid from '@emotion/is-prop-valid';
import styled, { css } from 'styled-components';
import { spacing } from '../../style';
import colors from '../../style/colors';

export interface UlProps {
  display?: React.CSSProperties['display'];
  gap?: keyof typeof spacing;
  children?: React.ReactNode;
  lastChildCss?: `border-bottom:none;` | 'border-right: none;';
  listStyleType?: React.CSSProperties['listStyleType'];
  flex?: React.CSSProperties['flex'];
  flexDirection?: React.CSSProperties['flexDirection'];
  flexGrow?: React.CSSProperties['flexGrow'];
  overflowY?: 'auto' | 'scroll';
  variant?:
    | 'gray900'
    | 'gray300'
    | 'white'
    | 'gray800'
    | 'gray600'
    | 'gray400'
    | 'gray100'
    | 'negative'
    | 'emerald'
    | 'teal'
    | 'darkTeal'
    | 'pumpkin'
    | 'darkPumpkin'
    | 'actionColorDark'
    | 'highlight'
    | 'positive'
    | 'attention'
    | 'violet'
    | 'darkViolet'
    | 'coral'
    | 'bubbleGum';
  ref?: React.Ref<HTMLUListElement>;
}

const UlComponent = styled.ul.withConfig({ shouldForwardProp: isPropValid })<UlProps>`
  display: ${props => props.display};
  flex-direction: ${props => props.flexDirection};
  margin: 0;
  padding: 0;
  flex-grow: ${props => props.flexGrow};
  padding-inline-start: 0;
  gap: ${props => spacing[props.gap || 'xs']};
  list-style-type: ${props => props.listStyleType || 'none'};
  flex: ${props => props.flex};
  overflow-y: ${props => props.overflowY};
  color: ${props => (props.variant ? colors[props.variant] : colors.gray900)};

  li:last-child {
    ${props => css`
      ${props.lastChildCss}
    `}
  }
`;

const ItemComponent = (props: any) => {
  return <li {...props} />;
};

const Ul: React.FunctionComponent<UlProps> & {
  Li: React.FunctionComponent<any>;
} = props => <UlComponent {...props} />;

Ul.Li = ItemComponent;

export { Ul };
